<template>
  <div
    v-if="overlay"
    :class="nukeOverlayClasses"
  >
    <div
      v-if="currentSlide"
      class="nuke-overlay__slide-name"
    >
      {{ currentSlide.name }}
    </div>
    <div class="nuke-overlay__badge">
      WZHUB.GG<span>/NUKE</span>
    </div>
    <div
      class="nuke-overlay__inner"
      :style="overlayStyles"
    >
      <div
        v-if="overlay.avatar"
        class="nuke-overlay__avatar"
      >
        <img
          :src="overlay.avatar"
          alt=""
          :style="avatarStyles"
        >
      </div>
      <div
        v-if="currentSlide"
        class="nuke-overlay-content"
      >
        <transition name="mslide">
          <div
            :key="currentSlide.id"
            class="nuke-overlay-content__slide"
          >
            {{ currentSlide.text }}
          </div>
        </transition>
      </div>
    </div>
    <img
      class="nuke-overlay__icon"
      :src="`/images/achievements/nukes2.svg`"
      :style="iconStyles"
    >
  </div>
</template>

<script>
export default {
  name: 'WZNukeOverlay',

  props: {
    overlay: {
      type: Object,
      default: null,
    },

    duration: {
      type: String,
      default: '3000',
    },
  },

  data() {
    return {
      idx: 0,
    };
  },

  computed: {

    filteredSlides() {
      if (!this.overlay) return [];

      const r = Object.entries(this.overlay.slides).filter(([, value]) => value.enabled);

      return r.map(([key, value]) => {
        let text = '';
        if (key === 'nuke-attempts') {
          text = value.text.replace('{value1}', value.value1);
          text = text.replace('{value2}', value.value2);
        } else {
          text = value.text.replace('{value}', value.value);
        }
        return {
          ...value,
          text,
        };
      });
    },

    nukeOverlayClasses() {
      return [
        'nuke-overlay',
        { 'nuke-overlay--has-avatar': !!this.overlay.avatar },
      ];
    },

    avatarStyles() {
      return {
        borderRadius: `calc(${this.overlay.styles.borderRadius}px / 1.5)`,
      };
    },

    iconStyles() {
      const time = this.overlay.icon.speed !== 0
        ? 10 / this.overlay.icon.speed
        : 0;
      return {
        animationName: 'rotation',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        animationDuration: `${time}s`,
      };
    },

    overlayStyles() {
      return {
        backgroundColor: this.overlay.styles.backgroundColor,
        borderColor: this.overlay.styles.borderColor,
        borderRadius: `${this.overlay.styles.borderRadius}px`,
        borderWidth: `${this.overlay.styles.borderWidth}px`,
        color: this.overlay.styles.textColor,
      };
    },

    currentSlide() {
      return this.filteredSlides.length > 0
        ? this.filteredSlides[this.idx]
        : null;
    },
  },

  mounted() {
    setInterval(() => {
      if (this.idx < this.filteredSlides.length - 1) {
        this.idx += 1;
      } else {
        this.idx = 0;
      }
    }, Number(this.duration));
  },

};
</script>

<style lang="scss">

.nuke-overlay {
  $this: '.nuke-overlay';
  padding: 10px 20px 10px 2px;

  position: relative;
  display: inline-block;

  &__inner {
    position: relative;
    width: 280px;
    height: 84px;
    padding: 12px;
    border: solid;
  }

  &--has-avatar {
    #{$this}__inner {
      width: 310px;
    }
    #{$this}__slide-name {
      left: 48%;
    }
    #{$this}__badge {
      left: 48%;
    }

    .nuke-overlay-content {
      left: 0px !important;
      right: 0px !important;
    }

  }

  &__avatar {
    height: 100%;
    img {
      height: 100%;
    }
  }

  &__slide-name {
    position: absolute;
    left: 41%;
    top: 0px;
    background: var(--colors-palette-primary);
    transform: translateX(-50%);
    padding: 5px 10px;
    color: #000;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    transition: 0.5s;
    text-transform: uppercase;
    z-index: 2;
  }

  &__badge {
    position: absolute;
    left: 41%;
    bottom: 0;
    background: #000;
    transform: translateX(-50%);
    padding: 5px 10px;
    color: var(--colors-utility-white);
    font-weight: 600;
    font-size: 12px;
    border-radius: 10px;
    z-index: 2;

    span {
      color: var(--colors-palette-primary);
    }
  }

  &__icon {
    position: absolute;
    top: 2px;
    right: 2px;
    height: 100px;
  }

  .nuke-overlay-content {
    position: absolute;
    top: 0;
    left: 3px;
    right: 40px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    &__slide {
      position: absolute;
      font-weight: 600;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5;
    }
  }

  .mslide-enter-active, .mslide-leave-active {
    transition: opacity .2s
  }
  .mslide-enter, .mslide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
  }

}

</style>
